export default __webpack_public_path__ + "static/media/smarthome.6219e07e.jpg";